import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

/** FEMA flood zone + stream context for a site (Stage 5). */
export default function SiteContext({ siteId }) {
  const [ctx, setCtx] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api(`/sites/${siteId}/context`)
      .then(setCtx)
      .catch((err) => setError(err.message));
  }, [siteId]);

  if (error) return <div className="rule-detail feed-note">Site context unavailable: {error}</div>;
  if (!ctx) return null;
  const z = ctx.floodZone;

  return (
    <section className="context-strip">
      <div>
        <div className="gauge-k">FEMA flood zone</div>
        {z?.error ? (
          <div className="rule-detail feed-note">{z.error}</div>
        ) : (
          <>
            <div className="gauge-v">
              {z?.zone ? `Zone ${z.zone}` : 'Not mapped'}
              {z?.specialFloodHazardArea && <span className="tag tag-planning" style={{ marginLeft: 8 }}>Special Flood Hazard Area</span>}
            </div>
            <div className="rule-detail">
              {z?.description}
              {z?.baseFloodElevationFt != null ? ` · base flood elevation ${z.baseFloodElevationFt} ft` : ''}
            </div>
            <div className="rule-detail muted">
              Mapped risk for insurance and floodplain rules — not a forecast. Sites outside a zone can still flood.{' '}
              {z?.viewerUrl && (
                <a href={z.viewerUrl} target="_blank" rel="noreferrer">
                  FEMA Flood Map Service Center
                </a>
              )}
            </div>
          </>
        )}
      </div>
      <div>
        <div className="gauge-k">Stream network</div>
        {ctx.stream?.error ? (
          <div className="rule-detail feed-note">{ctx.stream.error}</div>
        ) : ctx.stream ? (
          <>
            <div className="gauge-v">NHDPlus reach {ctx.stream.comid}</div>
            <div className="rule-detail">
              {ctx.stream.gaugesUpstream} USGS site(s) upstream and {ctx.stream.gaugesDownstream} downstream within 50 km — used
              to rank gauges when you add one.
            </div>
          </>
        ) : null}
      </div>
    </section>
  );
}
